const COMMON_PREFIX = "CART_ITEM";

export const CART_ITEMS_TEST_IDS = {
    CART_ITEM_NAME: `${COMMON_PREFIX}_NAME`,
    CART_ITEM_INC_BUTTON: `${COMMON_PREFIX}_INCREMENT_BUTTON`,
    CART_ITEM_DEC_BUTTON: `${COMMON_PREFIX}_DECREMENT_BUTTON`,
    CART_ITEM_QUANTITY: `${COMMON_PREFIX}_QUANTITY`,
    CART_ITEM_PRICE: `${COMMON_PREFIX}_PRICE`,
    CART_ITEM_STRIKED_PRICE: `${COMMON_PREFIX}_STRIKED_PRICE`,
    CART_ITEM_FREEBIE_ITEM: `${COMMON_PREFIX}_FREEBIE`,
    CART_ITEM_SUPER_ITEM: `${COMMON_PREFIX}_SUPER`,
    CART_ITEM_OOS_ITEM: `${COMMON_PREFIX}_OOS`,
    CART_ITEM_IN_STOCK_ITEM: `${COMMON_PREFIX}`,
    CART_ITEM_CUSTOMISE_BUTTON: `${COMMON_PREFIX}_CUSTOMISE_BUTTON`,
    CART_ITEM_OOS_ITEM_REMOVE_ICON: `${COMMON_PREFIX}_OOS_ITEM_REMOVE_ICON`,
    CART_ITEM_EXTRA_ITEM: `${COMMON_PREFIX}_EXTRA_ITEM`,
    CART_ITEM_TOGGLE_BUTTON: `${COMMON_PREFIX}_TOGGLE_BUTTON`,
    CART_ITEM_HEADER: `${COMMON_PREFIX}_HEADER`,
    CART_ITEM_IMAGE: `${COMMON_PREFIX}_IMAGE`,
    CART_ITEM_SUBTEXT: `${COMMON_PREFIX}_SUBTEXT`,
    CART_ITEM_VARIANTS_INFO: `${COMMON_PREFIX}_VARIANTS_INFO`,
    CART_ITEM_REMOVE_BUTTON: `${COMMON_PREFIX}_REMOVE_BUTTON`,
    CART_ITEM_FREEBIE_WRAPPER: `${COMMON_PREFIX}_FREEBIE_WRAPPER`,
    CART_ITEM_FREEBIE_HEADER_TEXT: `${COMMON_PREFIX}_FREEBIE_HEADER_TEXT`,
};

export const COMMENT_BOX_TEST_ID = "COMMENT_BOX";
export const COOKING_INSTRUCTION_INPUT_TEST_ID = "COOKING_INSTRUCTION_INPUT";
